import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import CronIcon from '@material-ui/icons/AvTimer';

import { CreateButton } from 'react-admin';

const CronEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <CronIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No cron available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default CronEmpty;
